import React from 'react';
import Card from './Card';

export default function PageLayout({ children, cardVariant = 'panel' }) {
  return (
    <div className="yk-page">
      {cardVariant === 'none' ? (
        <div style={{ width: '100%' }}>{children}</div>
      ) : (
        <Card variant={cardVariant}>
          <div className="yk-accent-line" />
          {children}
        </Card>
      )}
    </div>
  );
}
